import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { toast } from "react-toastify";
import { ImBin } from "react-icons/im";

import { MdOutlineModeEdit } from "react-icons/md";
import Swal from "sweetalert2";
import './style.css'
import fundo from "../../../../styles/fundo.svg";

const FormContainer = styled.form`
  width: auto;
  background-color: #f4f4f5;
  display: flex; 
  align-items: flex-start;
  flex-direction: row;
  box-shadow: 0px 0px 2px #ccc;
`;

const DivContainer = styled.form`
  width: 100%;
  background-color: #f4f4f5;
  display: flex; 
  align-items: flex-start;
  flex-direction: column;


  p {
    font-size: 18px;
    color: #3a3f42;
    margin: 10px 30px;
  }
`;

const Div = styled.div`
  width: 100%;
  background-color:#f4f4f5;
  display: flex; 
  align-items: flex-end;
  gap: 20px 0px;
  flex-direction: row;

`;
const Div2 = styled.div`

  background-color:#f4f4f5;
  display: flex; 
  padding: 10px 10px;
  align-items: flex-end;
  gap: 20px 0px;
  flex-direction: column;
 
`;




const InputArea2 = styled.div`
  width: auto;
  height: auto; 
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px 10px;

  select {
    width: 150px;
    height: 40px;
    border: 1px solid #ccc;
    border-radius: 10px;
    padding: 0px 10px;
    background-color: #f4f4f5;
    font-size: 18px;
    color: #3a3f42;

  }
  
`;


const InputDescricao = styled.textarea`
  width: 100%; 
  height: 140px; 
  border: 1px solid #ccc;
  border-radius: 10px;
  padding: 10px 10px 00px 20px;
  background-color: #f4f4f5;
  color: #3e3f42;
  font-size: 18px;
  resize: none; /* Desabilitar o redimensionamento manual */
  box-sizing: border-box; /* Incluir o padding e a borda na largura total */
  overflow: auto; /* Permitir a rolagem automática */
  white-space: pre-wrap; /* Manter quebras de linha e espaços */
`;





const Select = styled.input`
  width: 150px;
  height: 40px;
  border: 1px solid #ccc;
  border-radius: 10px;
  padding: 0px 10px;
  background-color: #f4f4f5;
  font-size: 18px;
  color: #3a3f42;

`;

const Label = styled.label`
  color: #3a3f42;
  font-weight: bold;
  font-family: 'Open Sans', sans-serif;
  font-size: 18px;
  margin: 0px 5px;
  padding: 0px 0px 0px 10px; 


`;

const Button = styled.button`
  width: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 10px ;
  cursor: pointer;
  border: none;
  background-image: url(${fundo});
  color: #fff;
  font-size: bold;
  font-size: 20px;
  gap: 5px;
  margin-top: 10px;
  border: 1px solid #ccc;
  border-radius: 10px;


`;




const DivList = styled.div`
  max-width:100%;
  background-color: #f4f4f5;
  display: flex; 
  padding: 10px 0px;
  align-items: start;
  gap: 10px;
  flex-direction: column;
  justify-content: space-between;
  color: #3a3f42;
`;

const Tr = styled.tr`
  text-align: center;
  padding-bottom: 05px;
  border: 1px solid #ccc;
`;

export const Td = styled.td`
  font-size: 18px;
  word-break: break-word;
  padding-top: 15px;
  padding-bottom: 5px;
  color: #3a3f42;
  p {
    color: #3a3f42;  
  }
`;
const TdButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px 10px;
  cursor: pointer;
  border: none;
  font-weight: bold;
  color: #575757;
  background-color: #f4f4f5;
  transition: transform 0.1s;
  &:hover {
    transform: scale(1.1);
  }
`;
const Table = styled.table`
  width: 1000px;
  background-color: #f4f4f5;
  color: #3a3f42;
  margin-top: 50px;
  padding: 0px 20px;
`;

export const Thead = styled.thead``;

export const Tbody = styled.tbody`
  padding-bottom: 05px; 
`;

export const Th = styled.th`
  color: #3a3f42;
  text-align: start;
  border-bottom: inset;
  padding-bottom: 5px;
`;


const DivInt = styled.div`
  width: 100%;
  background-color: #f4f4f5;
  display: flex; 
  flex-direction: column; /* Garantindo que os elementos dentro de DivInt fiquem em coluna */
  gap: 10px;
  color: #3a3f42;
`;



const Input = styled.input`
  width: 120px;
  height: 40px;
  border: 1px solid #ccc;
  border-radius: 10px;
  padding: 0px 10px;
  background-color: #f4f4f5;
  font-size: 18px;
  color: #3a3f42;
`;

const Form = ({ editarCartao, urlApi, usuario, checkbox, fetchCheckbox, visualizador, verQuadro }) => {


  //Token da api
  const token = localStorage.getItem('token');
  const id = Number(localStorage.getItem('id'));



  //---------------------------------PROPS PARA ADD E UPDATE TAREFA------------------------------------------//

  const [cardToEdit, setCardToEdit] = useState(null); // Guarda o cartão que será editado


  //-----------------------------EDITAR A TAREFA----------------------------------------------//
  const formatDate = (dateStr) => {
    // Exemplo: "30/04/2025" → "2025-04-30"
    const [day, month, year] = dateStr.split('/');
    return `${year}-${month}-${day}`;
  };

  const handleEdit = (check) => {

    setCardToEdit({
      descricao_tarefa: check.DESCRICAO_TAREFA,
      situacao: check.SITUACAO?.trim() || '', // garante compatibilidade
      id_responsavel_tarefa: check.ID_RESPONSAVEL_TAREFA,
      data_inicio: check.DATA_INICIO ? formatDate(check.DATA_INICIO) : '',
      data_conclusao: check.DATA_CONCLUSAO ? formatDate(check.DATA_CONCLUSAO) : '',
      valor: check.VALOR_TAREFA,
      id_tarefa: check.ID_TAREFA
    });
  };


  const opcoesSituacao = {
    AF: "A Fazer",
    PR: "Programado",
    AN: "Em Andamento",
    VA: "Em Validação",
    PA: "Pausado",
    CO: "Concluído",
    CA: "Cancelado",
    AR: "Arquivado",
  };
  //---------------------------FUNÇÂO QUE SALVA NOVAS E ALTERAÇÂO DAS TAREFAS------------------------------------------------//


  const handleCheckbox = async () => {

    const descricao_tarefaValue = cardToEdit.descricao_tarefa;
    const data_conclusaoValue = cardToEdit.data_conclusao;
    const id_responsavel_tarefaValue = cardToEdit.id_responsavel_tarefa;
    const valorValue = parseFloat(cardToEdit.valor) || 0;
    const data_inicioValue = cardToEdit.data_inicio;
    const situacaoValue = cardToEdit.situacao;


    if (!descricao_tarefaValue || !id_responsavel_tarefaValue || !situacaoValue) {
      return toast.warn("Preencha todos os campos!");
    }


    const onEditMetaConclusao = new Date(`${editarCartao.DATA_CONCLUSAO}T00:00:00`);
    const dataConclusaoValue = new Date(`${data_conclusaoValue}T00:00:00`);


    if (onEditMetaConclusao && dataConclusaoValue > onEditMetaConclusao) {
      toast.error(`A data da tarefa não pode ultrapassar a do cartão: ${onEditMetaConclusao.toLocaleDateString("pt-BR")}.`);
      return;
    }


    // Validação: data de início não pode ser maior que data de conclusão
    if (data_inicioValue > data_conclusaoValue) {
      toast.error(`A data de início não pode ser maior que a data de entrega.`);
      return;
    }


    if (cardToEdit.id_tarefa) {

      await axios
        .put(`${urlApi}painel-monitoramento/alterar-tarefa/${cardToEdit.id_tarefa}`, {
          descricao_tarefa: descricao_tarefaValue,
          data_conclusao: data_conclusaoValue,
          id_responsavel_tarefa: id_responsavel_tarefaValue,
          valor: valorValue,
          data_inicio: data_inicioValue,
          situacao: situacaoValue,
          id_alterou_tarefa: id,
        }, { headers: { Authorization: `Bearer ${token}` } })
        .then(async ({ data }) => {
          toast.success("Tarefa alterada com sucesso.");
        })

        .catch(async (error) => {
          if (error.response) {
            const errorMessage = error.response.data.error || 'Erro desconhecido';
            console.log("Error:", errorMessage);
            toast.error("Erro ao editar: " + errorMessage);

          } else {
            console.error('Erro inesperado:', error);
            toast.error('Erro inesperado.');

          }
        });

    } else {
      try {
        const requestData1 = {
          id_cartao: editarCartao.ID_CARTAO,
          descricao_tarefa: descricao_tarefaValue,
          data_conclusao: data_conclusaoValue,
          id_responsavel_tarefa: id_responsavel_tarefaValue,
          valor: valorValue,
          data_inicio: data_inicioValue,
          situacao: situacaoValue,
          id_criador_tarefa: id,
        };

        const usuarioSelecionado = usuario.find(user => user.COD_FUNCIONARIO == id_responsavel_tarefaValue);
        const email = usuarioSelecionado?.EMAIL || 'email-desconhecido@dominio.com';
        const nome = usuarioSelecionado?.NOME || 'Nome Desconhecido';

        await axios.post(`${urlApi}painel-monitoramento/nova-tarefa`, requestData1, { headers: { Authorization: `Bearer ${token}` } });

        enviarEmail({
          userTo: email,
          nomeUsuario: nome,
          criador: loginCriador,
          titulo: editarCartao.TITULO_CARTAO,
          titulo_quadro: verQuadro.TITULO_QUADRO
        });


        toast.success("Tarefa criada com sucesso.");

      } catch (error) {
        if (error.response) {
          const errorMessage = error.response.data.error;
          const details = error.response.data.details;
          const dbError = error.response.data.dbError;
          console.log("Error:", errorMessage);
          console.log("Details:", details);
          console.log("Database Error:", dbError);
          toast.error("Erro ao salvar os dados: " + errorMessage);
        }
      }
    }


    fetchCheckbox();
    setCardToEdit({
      descricao_tarefa: '',
      data_conclusao: '',
      data_inicio: '',
      id_responsavel_tarefa: '',
      valor: '',
      situacao: '',
    });

  };



  //---------------------------------ENVIAR EMAIL ---------------------------------------------------//

  //fornece o id para selecionar o email
  const usuarioCriador = usuario.find(user => user.COD_FUNCIONARIO == id);
  const loginCriador = usuarioCriador ? usuarioCriador.NOME : '';

  const enviarEmail = ({ userTo, nomeUsuario, criador, titulo, titulo_quadro }) => {

    axios.get(`${urlApi}painel-monitoramento/nova-tarefa`, {
      headers: { Authorization: `Bearer ${token}` },
      params: {
        userTo,
        nomeUsuario,
        criador,
        titulo,
        titulo_quadro
      }
    })
      .catch(error => {
        console.error("Erro ao enviar e-mail:", error);
      });
  };


  //---------------------------------DELETA TAREFAS------------------------------------------//

  const showPopUp = () => {
    return new Promise((resolve) => {
      Swal.fire({
        title: `Essa ação é irreversível, tem certeza que gostaria de continuar?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        customClass: {
          container: 'custom-swal-container', // Estiliza o container principal
          title: 'custom-swal-title', // Estiliza o título
          confirmButton: 'custom-swal-confirm-button', // Estiliza o botão de confirmação
          cancelButton: 'custom-swal-cancel-button', // Estiliza o botão de cancelamento
          popup: 'custom-swal-popup', // Estiliza o popup
          icon: 'custom-swal-icon' // Estiliza o ícone
        },
      }).then((result) => {
        resolve(result.value);
      });
    });
  };

  const handleDelete = async (check) => {
    const userConfirmed = await showPopUp();

    if (!userConfirmed) {
      return;
    }

    try {
      // Tenta realizar a requisição para deletar o usuário
      await axios.delete(`${urlApi}painel-monitoramento/deletar-tarefa/${check.ID_TAREFA}`, {
        headers: { Authorization: `Bearer ${token}` },
      });


      toast.success("Tarefa deletada com sucesso.");


      fetchCheckbox();
    } catch (error) {
      // Tratamento de erros
      console.error('Erro ao deletar o usuário:', error);

      let errorMessage = 'Erro desconhecido ao deletar.';
      if (error.response) {
        errorMessage = error.response.data || errorMessage;
        console.log('Erro na resposta:', error.response);
      } else if (error.request) {
        console.log('Erro na requisição:', error.request);
      } else {
        console.log('Erro na configuração da requisição:', error.message);
      }

      toast.error(errorMessage);


    }

  };









  //---------------------FILTRA OS USUARIOS------------------------------------//
  const usuariosVisualizadores = visualizador
    .filter(v => v.ID_QUADRO === editarCartao.ID_QUADRO) // Ou editarCartao.id_quadro, caso seja um quadro e não coluna
    .map(v => usuario.find(user => user.COD_FUNCIONARIO === v.COD_FUNCIONARIO)) // Mapeia para encontrar os usuários correspondentes
    .filter(Boolean); // Remove possíveis undefined caso algum id_usuario não seja encontrado
























  //------------------------------------------PODE EDITAR----------------------//

  const podeEditar = id === editarCartao?.ID_CRIADOR || id === editarCartao?.ID_COCRIADOR;
  const podeEditarFull1 = id === editarCartao?.ID_CRIADOR || id === editarCartao?.ID_COCRIADOR || id === editarCartao?.ID_RESPONSAVEL;
  const quadroLivre = verQuadro.LIVRE === 'S';


  return (
    <div >
      <FormContainer>
        <DivContainer  >
          <>
            {(podeEditarFull1 || quadroLivre) && (
              <Div2>
                <DivList>
                  <DivInt>
                    <InputDescricao
                      placeholder="Escreva a descrição da tarefa"
                      name="descricao_tarefa"
                      type="text"
                      value={cardToEdit ? cardToEdit.descricao_tarefa : ''} // Exibe o valor de cardToEdit se estiver definido
                      onChange={(e) => setCardToEdit({ ...cardToEdit, descricao_tarefa: e.target.value })}
                    />
                  </DivInt>
                  <Div>
                    <InputArea2>
                      <Label>Responsável:</Label>
                      <select
                        name="id_responsavel_tarefa"
                        isSearchable
                        value={String(cardToEdit?.id_responsavel_tarefa || '')} // Exibe o responsável de cardToEdit se estiver definido
                        onChange={(e) => {
                          setCardToEdit({ ...cardToEdit, id_responsavel_tarefa: e.target.value });

                        }}
                      >
                        <option value="">Escolha</option>
                        {usuariosVisualizadores.map((user, i) => (
                          <option key={i} value={String(user.COD_FUNCIONARIO)}>
                            {user.LOGON} - {user.NOME}
                          </option>
                        ))}
                      </select>
                    </InputArea2>
                    <InputArea2>
                      <Label>Situação:</Label>
                      <select
                        name="situacao"
                        value={cardToEdit ? cardToEdit.situacao : ''}
                        onChange={(e) => setCardToEdit({ ...cardToEdit, situacao: e.target.value })}
                      >
                        <option value="" disabled>Escolha...</option>
                        {Object.entries(opcoesSituacao).map(([valor, label]) => (
                          <option key={valor} value={valor}>{label}</option>
                        ))}
                      </select>

                    </InputArea2>
                    <InputArea2>
                      <Label>Data inicio:</Label>
                      <Select
                        name="data_inicio"
                        type="date"
                        min={new Date().toISOString().split("T")[0]}
                        value={cardToEdit ? cardToEdit.data_inicio : ''} // Exibe a data de cardToEdit se estiver definida
                        onChange={(e) => setCardToEdit({ ...cardToEdit, data_inicio: e.target.value })}
                      />
                    </InputArea2>
                    <InputArea2>
                      <Label>Data de entrega:</Label>
                      <Select
                        name="meta_conclusao"
                        type="date"
                        min={new Date().toISOString().split("T")[0]}
                        value={cardToEdit ? cardToEdit.data_conclusao : ''} // Exibe a data de cardToEdit se estiver definida
                        onChange={(e) => setCardToEdit({ ...cardToEdit, data_conclusao: e.target.value })}
                      />
                    </InputArea2>

                    <InputArea2>
                      <Label>Valor:</Label>

                      <Input
                        name="valor"
                        type="number"
                        step="0.01"
                        placeholder="ex. 1000.00"
                        value={cardToEdit?.valor || ''}
                        onChange={(e) => setCardToEdit({ ...cardToEdit, valor: e.target.value })}
                      />
                    </InputArea2>
                    <Button type="button" onClick={() => handleCheckbox()}>
                      Salvar
                    </Button>
                  </Div>
                </DivList>
              </Div2>

            )}
          </>



          <>
            {(checkbox.length > 0) ? (
              <Div>
                <Table>
                  <>
                    {checkbox.length > 0 && (

                      <Tbody >
                        {checkbox.map((check) => {
                          // Busca o responsável pela tarefa

                          return (
                            <Tr key={check.ID_TAREFA}>

                              <Td width="70%" style={{ textAlign: 'left' }}>

                                <span>
                                  {check.DESCRICAO_TAREFA}
                                </span>

                                <div style={{ marginTop: '5px', color: '#BFBFBF' }}>
                                  Responsável: {check.NOME_RESPONSAVEL_TAREFA} {/* Exibe o login do responsável */}
                                </div>

                              </Td>

                              {(podeEditarFull1 || quadroLivre) && (
                                <Td style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
                                  <TdButton onClick={() => handleEdit(check)} type="button">
                                    <MdOutlineModeEdit size={24} color="Gold" /> Editar
                                  </TdButton>
                                  <TdButton onClick={() => handleDelete(check)} type="button">
                                    <ImBin size={24} color="Red" /> Deletar
                                  </TdButton>
                                </Td>
                              )}
                            </Tr>
                          );
                        })}

                      </Tbody>
                    )}
                  </>
                </Table>
              </Div>
            ) : (
              <p>Não a nenhuma tarefa criada!</p>
            )}
          </>
        </DivContainer>
      </FormContainer>


      <style jsx global>{`
      .swal2-container.custom-swal-container {
        z-index: 9999; 
      }
    `}</style>
    </div >

  );
};

export default Form;


